export default __webpack_public_path__ + "static/media/pa_3.0396941b.mp3";